import React, { ReactElement } from 'react';

const FuneralIcon = (): ReactElement | null => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="94"
      fill="none"
      viewBox="0 0 108 94"
    >
      <path
        fill="#EBFAF1"
        d="M67.622 0H40.467C23.088 0 9 14.07 9 31.424V62.12c0 17.355 14.088 31.424 31.467 31.424h27.155c17.379 0 31.466-14.069 31.466-31.424V31.425C99.088 14.068 85.001 0 67.623 0z"
      ></path>
      <path
        fill="#C0EFD3"
        d="M78.85 73.797a2.459 2.459 0 003.47-.225 2.459 2.459 0 00-.23-3.47 2.459 2.459 0 00-3.47.225 2.459 2.459 0 00.23 3.47zM26.46 68.915c1.36 0 2.461-1.1 2.461-2.458A2.459 2.459 0 0026.461 64C25.1 64 24 65.1 24 66.457a2.459 2.459 0 002.46 2.458z"
      ></path>
      <path
        stroke="#2ECC71"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M91.098 67.63a2.604 2.604 0 003.674-.238 2.604 2.604 0 00-.244-3.674 2.604 2.604 0 00-3.674.239 2.604 2.604 0 00.244 3.674zM15.605 64.204a2.604 2.604 0 002.606-2.602A2.604 2.604 0 0015.605 59 2.604 2.604 0 0013 61.602a2.604 2.604 0 002.605 2.602z"
      ></path>
      <path
        stroke="#96E5B7"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1 80h106"
      ></path>
      <path
        fill="#C0EFD3"
        stroke="#2ECC71"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M71 77.99V51.851c-.4-7.574-5.226-20.506-21-15.875L65.648 80 71 77.99z"
      ></path>
      <path
        fill="#EBFAF1"
        stroke="#2ECC71"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M37 50.5C37 42.492 43.492 36 51.5 36S66 42.492 66 50.5V80H37V50.5z"
      ></path>
      <path
        stroke="#2ECC71"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M56 73h-9M56 66h-9M59 60H43"
      ></path>
      <ellipse
        cx="51"
        cy="48.5"
        stroke="#2ECC71"
        strokeWidth="2"
        rx="4"
        ry="4.5"
      ></ellipse>
    </svg>
  );
};

export default FuneralIcon;
